export const createFieldArrayInputName = (
  fieldArrayName: string,
  index: number,
  name: string,
) => `${fieldArrayName}[${index}].${name}`;

export const createFieldArrayFieldSelector = (
  fieldArrayName: string,
  index: number,
) => `${fieldArrayName}[${index}]`;
